import * as React from "react";
import '../styles/Availability.css';

export default function AvailabilityBadge(props) {
    return <div className={"availability-wrapper pill" + (props.className ? " " + props.className : "")}>
        <div className={"available"}>
            <div className={"circle-1"}></div>
            <div className={"circle-2"}></div>
            <div className={"circle-3"}></div>
        </div>
        {props.label}
    </div>
}